/**
 * This function assumes that an input with a time zone has to be treated as UTC.
 * This is helpful to correct dates stored in database with the wrong time zone.
 *
 * @param {string} dateStr
 * @returns {Date} date object with the adjustments from the target time zone
 */
function utcDate(dateStr) {
    const ts = Date.parse(dateStr);
    if (!ts) {
        throw new Error('Invalid Date');
    }

    const date = new Date(ts);
    if (hasTimezone(dateStr)) {
        return new Date(date.getTime() + date.getTimezoneOffset() * 6e4);
    }

    return date;
}

const patterns = [
    /(Z)$/, // Z
    /([+-])(\d{2})$/, // ±hh
    /([+-])(\d{2}):?(\d{2})$/, // ±hh:mm or ±hhmm
    /(UTC|(?:[a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?))$/, // IANA time zone
];

/**
 * Returns true if it matches any of the time zone offset formats
 *
 * @param {string} timezoneString
 * @returns {boolean}
 */
function hasTimezone(timezoneString) {
    return patterns.some((pattern) => pattern.exec(timezoneString));
}

export default utcDate



// WEBPACK FOOTER //
// ./src/utility/utcDate.js